import DocumentIcon from '@heroicons/react/outline/DocumentIcon'
import { Link } from 'react-router-dom'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { EmptyState } from '@tribeplatform/react-ui-kit/EmptyState'
import { Container } from '@tribeplatform/react-ui-kit/Layout'

export const NotFound = ({ title = '', description = '', icon = false }) => {
  return (
    <Container>
      <Card>
        <Card.Content>
          <div className="py-12">
            <EmptyState
              icon={icon || <DocumentIcon />}
              title={title || 'Page not found!'}
              description={
                description ||
                "We were not able to find the page you're looking for."
              }
            >
              <Button variant="outline" as={Link} to="/">
                Home
              </Button>
            </EmptyState>
          </div>
        </Card.Content>
      </Card>
    </Container>
  )
}
